export const version = "abstract-provider/5.8.0";
//# sourceMappingURL=_version.js.map